import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Panel, Pill } from "@/components/Bits";
import { motion } from "framer-motion";
import MediaFile from "@/components/MediaFile";

export default function ParentTimeline() {
  const [updates, setUpdates] = useState([]);
  const [students, setStudents] = useState([]);
  useEffect(() => {
    Promise.all([api.get("/daily-updates"), api.get("/students")]).then(([u, s]) => { setUpdates(u.data); setStudents(s.data); });
  }, []);
  const child = students[0];

  return (
    <div>
      <PageHeader eyebrow="Timeline" title={child ? `${child.name}'s journey` : "Daily journey"} subtitle="Every little moment, beautifully laid out." />

      <div className="relative max-w-3xl">
        <div className="absolute left-4 top-0 bottom-0 w-px bg-border" />
        <div className="space-y-5">
          {updates.map((u, idx) => (
            <motion.div key={u.update_id} initial={{ opacity: 0, x: -8 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: idx * 0.03 }} className="relative pl-12">
              <div className="absolute left-2 top-3 w-5 h-5 rounded-full bg-terracotta border-4 border-white shadow" />
              <div className="bg-white rounded-3xl border border-border p-5">
                <div className="flex items-center justify-between">
                  <div className="text-sm font-semibold">{u.date}</div>
                  <Pill tone="mustard">{u.mood}</Pill>
                </div>
                {u.activities?.length > 0 && (
                  <div className="mt-3 space-y-1 text-sm">{u.activities.map((a, i) => <div key={i}>• {a}</div>)}</div>
                )}
                {u.media?.length > 0 && (
                  <div className="mt-3 grid grid-cols-3 gap-2">
                    {u.media.map((fid) => (
                      <MediaFile key={fid} fileId={fid} className="w-full h-24 rounded-xl object-cover bg-paper-alt" />
                    ))}
                  </div>
                )}
                {u.meals && (
                  <div className="mt-3 grid grid-cols-3 gap-2 text-xs">
                    <div className="bg-paper-alt rounded-xl p-2"><div className="text-ink-soft">Breakfast</div><div className="font-semibold capitalize">{u.meals.breakfast}</div></div>
                    <div className="bg-paper-alt rounded-xl p-2"><div className="text-ink-soft">Lunch</div><div className="font-semibold capitalize">{u.meals.lunch}</div></div>
                    <div className="bg-paper-alt rounded-xl p-2"><div className="text-ink-soft">Nap</div><div className="font-semibold capitalize">{u.nap?.quality}</div></div>
                  </div>
                )}
                {u.milestones?.length > 0 && (
                  <div className="mt-3 p-3 bg-sage-soft text-sage-deep text-sm rounded-2xl"><strong>Milestone:</strong> {u.milestones[0]}</div>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
